
<style src="./bootstrap.min.css" scoped>

</style>
<style lang="less">
    .center-wrapper {
    width: 30rem;
    margin: auto;
}

#try_on_stage {
    height: 30rem;
    width: 30rem;
    overflow: hidden;
    margin:0 auto;
}

.ajax-loading {
    display: none;
    position: fixed;
    z-index:10;
    top: 20%;
    left: 50%;
    opacity: .8;
    height: 100px;
    width: 100px;
    transform: translate(-50%);
}
.ajax-loading img {
    width: 100%;
}
</style>
<template>
  <div style="margin-top:10px;">
    <div class="center-wrapper container">
        <div id="js_ajax_loading" class="ajax-loading">
		<!-- <img src="https://media.giphy.com/media/y1ZBcOGOOtlpC/giphy.gif" alt=""> -->
	</div>

	<div id="try_on_stage"></div>

    <br>
    <div class="d-flex justify-content-between">
	  <button
      class="btn btn-secondary"
       @click="initTryOn()"
       >开始试戴</button>

	  <button
      class="btn btn-secondary"
      @click="changeUserImage()" >切换用户图片</button>


	  <button
      class="btn btn-secondary"
      @click="changeAll()" >更换素材</button>

	  <button
      class="btn btn-secondary"
      @click="reset()" >重置</button>
    </div>
       <br>
     <div class="col-auto">
	  <form id="adjust_pd" >
                 <div class="input-group">
                    <span class="input-group-addon" >瞳距</span>
                    <input type="text" class="form-control" placeholder="3.5"
                           id="user_pd" name="user"  value="47"
                           @change="changePD()"
                    >
                    <span class="input-group-addon" >mm</span>
                </div>

                  <br>

                <div class="input-group">
                    <span class="input-group-addon" >镜片中心距</span>
                    <input type="text" class="form-control" placeholder="3.5"
                           id="frame_pd" name="frame"  value="47"
                           @change="changePD()"
                    >
                    <span class="input-group-addon" >mm</span>
                </div>


	</form>
     </div>

     <br>

         <div class="col-auto">
            <label for="roll_angle">镜框旋转</label>
            <input id="roll_angle"
                    type="range" max="50" min="-50" step="0.1"
                    @input="rotateFrame($event)"
			        @change="rotateFrame($event)">
        </div>

      <br>

         <div class="col-auto">
            <form id="upload_user_form">
                <label for="user_img_input">上传</label>
                <input name="user_img" @change="imageFileTryOn()" type="file" id="user_img_input">

            </form>
        </div>


	<!-- <form id="upload_user_form">
		<label for="user_img_input">上传</label>
		<input name="user_img" type="file" id="user_img_input">
		<button type="button" @click="imageFileTryOn()" >试戴本地用户图片</button>
	</!-->

     <!-- iframe的方式暂时 -->
      <!-- <iframe  name = "child" id = "child" v-bind:src="reportUrl"
   width="auto" height="300"
     frameborder="0" scrolling="no"  style="width:100%;height:1000px"
    ></iframe> -->


    </div>
  </div>
</template>

<script>


var asset_key = [
      "2a6f7086-9688-11ea-9800-00163e0a7363",
      "3c1e6bf2-9688-11ea-b4c4-00163e0a7363",
      "43916588-9688-11ea-8e6f-00163e0a7363",
      "4a0d05c0-9688-11ea-8964-00163e0a7363",
      "5010cfe2-9688-11ea-bff5-00163e0a7363"
  ];


import { XjTryOn } from '../../../../xj-tryon2';
// import './hammer.min.js';


export default {
    data(){
        return{
            XJ:null,
            center_shift_pos:{ x : 0  , y : 0 },
            reportUrl: 'https://tryon.xiaojingxiuxiu.com/demo/tryon-demo.html',//iframe的网址
            two_d_frames:[
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_002.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_003.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_004.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_005.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_006.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_007.png"
        ],

           two_d_temples:[
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_001_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_002_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_003_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_004_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_005_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_006_001.png",
            "https://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_BL6001_material_007_001.png"
        ],

        }
    },
    mounted() {

    var config = {

            // 试戴区域挂载元素 id 必需是个块级元素
            el : '#try_on_stage' ,

            // 也可以在模块初始化的同时
            // 初始化素材
            // user_img : 'http://gz.bcebos.com/benyamin/wemall/user/face/oTKMAtwbkkEP62OkcZ3FG_82T1d8.jpg' ,

            // frame_img : 'http://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_4187_material_001.png' ,

            // temple_img : 'http://gz.bcebos.com/benyamin/wemall/glass/assets/2d_temples%242y%2410%24aPpOxkw7srkDK7froY/L9u2GoMknCjDF.NX4yMtT71W7OqnBOcf9G_2017_02_24.png'
        };


        	this.XJ = XjTryOn(config);



		// 如果需要处理一些回调事件
		// 可以订阅下列事件

		// 调用 tryOn 方法会触发下列事件
		// tryon.start
		// tryon.error
		// tryon.done

		// 调用 adjust 方法会触发下列事件
		// adjust.start
		// adjust.done

		// 调用 reset 方法会触发下列事件
		// reset.start
		// reset.done
		//
		// 比如显示加载 loading 图片
		var loading_elem = document.getElementById('js_ajax_loading');
		this.XJ.on('tryon.start' , function () {
			loading_elem.style.display = 'inherit';
			console.info('tryon is begin');
		})
		.on('tryon.done' , function () {
			loading_elem.style.display = 'none';
			console.info('tryon is ok');
            // 初始化一个 hammer js 单例
            singleHammer();
		})
		.on('tryon.error' , function ( msg ) {
			loading_elem.style.display = 'none';
			alert( "试戴失败：" + msg );
			console.warn( msg );
        });

    const that =this;



      var singleHammer = function singleton(initialized) {

        return function initializeHammer() {
          return initialized || (initialized = that.hammerInit());
        };
      }(false);

       this.center_shift_pos = {x: 0, y: 0};


    },
    methods: {
        randAsset() {
          return asset_key[parseInt(asset_key.length * Math.random())]
        },
        singleHammer(initialized){

             function singleton( initialized ){
                return function initializeHammer(){
                    return initialized || ( initialized = hammerInit() );
                };
            }(false)
        },



        initTryOn(){
             // console.log(this.XJ);

        let item = parseInt(asset_key.length * Math.random());

			// 初始化素材
			this.XJ.tryOn({
				user_img : this.modelImageUrl(3) ,

               asset_key: asset_key[item],

				// frame_img : 'https://try-on-api.gz.bcebos.com/demo-assets/2d_panx_America_001.png' ,

				// temple_img : 'https://try-on-api.gz.bcebos.com/demo-assets/2d_panx_America_001_001.png'
			});

			// 初始化一个 hammer js 单例
			// this.singleHammer();
        },



        hammerInit(){

		    // 初始化 hammer 操作平面元素
		    var stage = document.getElementById('try_on_stage');
		    var mc = new Hammer.Manager(stage);
            var thct = this;
		    // 绑定手势
		    var Pan = new Hammer.Pan();
		    var DoubleTap = new Hammer.Tap({
		        event: 'doubletap',
		        taps: 2
		    });

		    mc.add(Pan);
		    mc.add(DoubleTap);

		    // 添加平移眼镜相关回调
		    mc.on('pan', function panGlass(e) {

		            var center_shift = {
		                x : thct.center_shift_pos.x + e.deltaX,
		                y : thct.center_shift_pos.y + e.deltaY
		            };

		            thct.XJ.adjust( {
		            	frame_center : center_shift ,
		            });

		    });
		    mc.on('panend', function(e) {

		    	thct.center_shift_pos = {
		    		x : thct.center_shift_pos.x + e.deltaX ,
		    		y : thct.center_shift_pos.y + e.deltaY
		    	}
		    });

		    // 重置眼镜位置
		    mc.on('doubletap', function() {
		    	thct.center_shift_pos = { x : 0 , y : 0 };

		    	// 可以调用 this.XJ.rest() 重置眼镜位置
		        thct.XJ.reset();
		    });



		    return true;
        },

        	// 替换用户图片
		changeUserImage(){

			// 可以分别切换素材 ，根据参数不同 ，自动判断并试戴
			this.XJ.tryOn({
				user_img : this.randUserImage( 0, 13 )
			});

		},

		// 全部素材替换
		changeAll(){

        let item = parseInt(asset_key.length * Math.random());



			this.XJ.tryOn({

				user_img : this.modelImageUrl(9),

                asset_key: asset_key[item],

			     // frame_img : this.two_d_frames[item],

        //         temple_img : this.two_d_temples[item],

				reset : true
			});

		},

		// 调整瞳距
		changePD(){
			var adjust_form = document.getElementById('adjust_pd');
			var user_pd = adjust_form.user.value || 47;
			var frame_pd = adjust_form.frame.value || 47;

			// 如需调整瞳距 请同时输入
			// pd.user 为用户输入瞳距
			// pd.frame 为 A位宽 + DBL （真实眼镜的默认参数，请自己计算传入）
			this.XJ.adjust({
				pd : {
					user : user_pd ,
					frame : frame_pd
				}
			});
		},

		// 旋转眼镜
		rotateFrame( degree ){
            // console.log(degree.target.value);


            // 	pose = {
            // 		roll_angle : 0 ,  //  眼镜z轴旋转角度偏移
            // 		pitch_angle : 0 , //  眼镜x轴旋转角度偏移
            // 		yaw_angle : 0 ,   //   眼镜y轴旋转角度偏移
            // 	}

			this.XJ.adjust({
        		pose : {
            		roll_angle : degree.target.value,
            		pitch_angle : 0 ,
            		yaw_angle : 0
            	},
            });
		},


		// 重置眼镜位置
		reset(){

			this.XJ.reset();

			// 网页上的调整参数也要同时重置
			this.center_shift_pos = { x : 0  , y : 0 };

			var adjust_form = document.getElementById('adjust_pd');
				adjust_form.user.value = 47;
				adjust_form.frame.value = 47;

			var rotate_input = document.getElementById('roll_angle');
				rotate_input.value = 0;
		},

		// 上传本地用户图片，需要传入 file input 元素的 id selector
		imageFileTryOn(){
             if (! this.isFileExist(event.target)) {
                alert('请先选择一张正面头部图片,再点击试戴');
                return event.target.click();
            }

            var thach = this;
			this.XJ.tryOn({
				user_img_el : "#user_img_input",
                asset_key: thach.randAsset()
			});

		},

		// 获取指定用户图片地址
		modelImageUrl( index ) { // 1 -16
			return "http://try-on-api.gz.bcebos.com/demo-assets/user-model/" + index + ".jpg";
		},


        randUserImage(old_index){

        function random(min, max) {
          return Math.floor(Math.random() * (max - min)) + min;
        }
				var new_index = random(0, 13);
				if ( new_index == old_index ) {
					return this.randUserImage( 0 , 13 );
				} else {
					old_index = new_index
					return this.modelImageUrl( new_index );
				}

        },


		randInt( floor , ceil ){
			return Math.round( Math.random() * ( ceil - floor ) ) + parseInt( floor );
        },

         isFileExist(file_elem) {
        return file_elem.files.length > 0
    }

    }
}
</script>
